import React from 'react';
import { Route } from 'react-router';
import About from './components/About';
import Billing from './components/Billing';
import EditBillableItem from './components/EditBillableItem';
import CacheBuster from './CacheBuster';
import CreateAccount from './components/CreateAccount';
import CreatePatient from './components/CreatePatient';
import CreateRecord from './components/CreateRecord';
import CreateSite from './components/CreateSite';
import CreateSponsor from './components/CreateSponsor';
import CreateStudy from './components/CreateStudy';
import ForgotPassword from './components/ForgotPassword';
import Home from './components/Home';
import Layout from './components/Layout';
import LinkSites from './components/LinkSites';
import LinkStudies from './components/LinkStudies';
import ManageAccounts from './components/ManageAccounts';
import ManagePatients from './components/ManagePatients';
import ManageSites from './components/ManageSites';
import ManageSponsors from './components/ManageSponsors';
import ManageStudies from './components/ManageStudies';
import ResetPassword from './components/ResetPassword';
import SelectPatient from './components/SelectPatient';
import Dashboard from './components/Dashboard';
import SelectRecord from './components/SelectRecord';
import ViewRecord from './components/ViewRecord';
import SelectSite from './components/SelectSite';
import SelectSponsor from './components/SelectSponsor';
import SelectStudy from './components/SelectStudy';
import SelectStudySite from './components/SelectStudySite';
import UserSettings from './components/UserSettings';
import * as paths from './data/Paths';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';


function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

class App extends React.Component {
    componentDidMount() {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.setAttribute('data-jsd-embedded', null);
        script.setAttribute('data-key', '4c47191c-7b66-46b8-9d98-14add82e7a35');
        script.setAttribute('data-base-url', 'https://jsd-widget.atlassian.com');
        script.onload = function () {
            var event = document.createEvent('Event');
            event.initEvent('DOMContentLoaded', true, true);
            window.document.dispatchEvent(event);
        };
        script.src = 'https://jsd-widget.atlassian.com/assets/embed.js';
        document.body.appendChild(script);
    }

    render() {
        return (
            <CacheBuster>
                {({ emptyCacheAndReload, isCurrentVersion, loading }) => {
                    if (loading) {
                        return null;
                    }
                    if (!loading &&
                        !isCurrentVersion) {
                        sleep(3000)
                            .then(() => {
                                emptyCacheAndReload();
                            });
                    }

                    return (
                        <Layout>
                            <Route path={paths.about} component={About} />
                            <Route path={paths.account} component={CreateAccount} />
                            <Route path={paths.billing} component={Billing} />
                            <Route path={paths.editBillableItem} component={EditBillableItem} />
                            <Route path={paths.createAccount} component={CreateAccount} />
                            <Route path={paths.createPatient} component={CreatePatient} />
                            <Route path={paths.patient} component={CreatePatient} />
                            <Route path={paths.createRecord} component={CreateRecord} />
                            <Route path={paths.createSite} component={CreateSite} />
                            <Route path={paths.site} component={CreateSite} />
                            <Route path={paths.createSponsor} component={CreateSponsor} />
                            <Route path={paths.sponsor} component={CreateSponsor} />
                            <Route path={paths.createStudy} component={CreateStudy} />
                            <Route path={paths.study} component={CreateStudy} />
                            <Route path={paths.forgotPassword} component={ForgotPassword} />
                            <Route exact path={paths.home} component={Home} />
                            <Route path={paths.linkSites} component={LinkSites} />
                            <Route path={paths.linkStudies} component={LinkStudies} />
                            <Route path={paths.manageAccounts} component={ManageAccounts} />
                            <Route path={paths.managePatients} component={ManagePatients} />
                            <Route path={paths.manageSites} component={ManageSites} />
                            <Route path={paths.manageSponsors} component={ManageSponsors} />
                            <Route path={paths.manageStudies} component={ManageStudies} />
                            <Route path={paths.resetPassword} component={ResetPassword} />
                            <Route path={paths.selectPatient} component={SelectPatient} />
                            <Route path={paths.dashboard} component={Dashboard} />
                            <Route path={paths.selectRecord} component={SelectRecord} />
                            <Route path={paths.viewRecord} component={ViewRecord} />
                            <Route path={paths.selectSite} component={SelectSite} />
                            <Route path={paths.linkSponsor} component={SelectSponsor} />
                            <Route path={paths.selectSponsor} component={SelectSponsor} />
                            <Route path={paths.selectStudy} component={SelectStudy} />
                            <Route path={paths.selectStudySite} component={SelectStudySite} />
                            <Route path={paths.settings} component={UserSettings} />
                        </Layout>
                    );
                }}
            </CacheBuster>
        );
    }
}

export default DragDropContext(HTML5Backend)(App);



// WEBPACK FOOTER //
// ./src/App.js